import { render } from "./BackToTop.vue?vue&type=template&id=5eec64ea"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Laragon\\1 Asakeeb Versions\\project\\vdemy-vue - Copy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__